import { normalizeDateNumber } from "../../utils/AppFunction";
import { ITiepDon } from "../models/TiepDonModel";
import address
  from "../../phan-he-noi-tru-dieu-tri/components/benh-an/components/content/components/thong-tin-benh-an/components/giay-bao-tu/components/Address";
import {ADDRESS_PREFIX} from "../constants/variables";

export const getInitialDateValue = (objectValue: Record<string, any>, fieldPrefix: string) => {
    if (!objectValue) return null;

    const day = objectValue[`${fieldPrefix}Day`];
    const month = objectValue[`${fieldPrefix}Month`];
    const year = objectValue[`${fieldPrefix}Year`];

    return {
        [`${fieldPrefix}Day`]: day ? `${day}`.padStart(2, '0') : null,
        [`${fieldPrefix}Month`]: month ? `${month}`.padStart(2, '0') : null,
        [`${fieldPrefix}Year`]: year ?? null,
    }
};

export const convertToObject = (field: string, data: any) => {
    if (!data) return null;

    return (data[field + "Id"] && data[field + "Name"]) ? {
        id: data[field + "Id"],
        name: data[field + "Name"],
        code: data[field + "Code"],
    } : null;
};

export const convertAdditionalForm = (data: any) => {
  const additionalForms = data?.additionalForms || {};

  return {
    ...additionalForms,
    familyRecords1: {
      ...additionalForms.familyRecords1,
      fmlName: additionalForms.familyRecords1?.fmlName || data?.patient?.hoTenBo || data?.hoTenBo,
    },
    familyRecords2: {
      ...additionalForms.familyRecords2,
      fmlName: additionalForms.familyRecords2?.fmlName || data?.patient?.hoTenMe || data?.hoTenMe,
    },
  }
}

export const convertDataBenhNhan = (data: any, listPolicyCode?: any[]): ITiepDon => {
    return {
      ...data,
      additionalForms: convertAdditionalForm(data),
        patient: {
          ...data?.patient,
          address: data?.patient?.town || data?.patient?.address,
          personName: data?.patient?.hoTen || data?.patient?.personName,
          dobDay: data?.patient?.ngaySinh || data?.patient?.dobDay,
          dobMonth: data?.patient?.thangSinh || data?.patient?.dobMonth,
          dobYear: data?.patient?.namSinh || data?.patient?.dobYear,
            person: {
                ...data?.patient?.person,
                ...getInitialDateValue(data?.patient, 'dob'),
              dobDay: normalizeDateNumber(data?.patient?.ngaySinh || data?.patient?.dobDay),
              dobMonth: normalizeDateNumber(data?.patient?.thangSinh || data?.patient?.dobMonth),
              dobYear: data?.patient?.namSinh || data?.patient?.dobYear,
                fullName: data?.patient?.hoTen || data?.patient?.personName,
                phoneNumber: data?.patient?.phoneNumber || '',
                idNumber: data?.patient?.idNumber,
                gender: data?.patient?.genderOption || { name: data?.patient?.gender },
                ccountry: convertToObject('country', data?.patient),
            },
            ethnicity: data?.patient?.ethnicity || convertToObject('ethnicity', data?.patient),
            province: data?.patient?.provinceOption || convertToObject('province', data?.patient),
            district: data?.patient?.districtOption || convertToObject('district', data?.patient),
            commune: data?.patient?.wardOption || convertToObject('commune', data?.patient),
            occupation: convertToObject('occupation', data?.patient),
            referrer: data?.patient?.referrerCode
                ? {
                    code: data?.patient?.referrerCode || '',
                    name: data?.patient?.referrerName || '',
                }
                : null,
        },
        visit: {
            ...data?.visit,
            visitObjectType:
                convertToObject('visitObjectType', data?.visit) || data?.visit?.visitObjectType,
            policyCode: (() => {
                // Nếu đã là object thì giữ nguyên
                if (data?.visit?.policyCode && typeof data.visit.policyCode === 'object') {
                    return data.visit.policyCode;
                }
                // Backend trả về string, cần filter từ listPolicyCode
                if (data?.visit?.policyCode && typeof data.visit.policyCode === 'string') {
                    const found = listPolicyCode?.find((item: any) =>
                        item?.code === data.visit.policyCode || item?.id === data.visit.policyCode
                    );
                    return found || { code: data.visit.policyCode, name: data.visit.policyCode };
                }
                return null;
            })(),
            visitReason: data?.visit?.visitReasonName,
            visitType: convertToObject('visitType', data?.visit) ?? data?.visit?.visitType,
            service: convertToObject('termSvc', data?.visit),
            dept: convertToObject('dept', data?.visit),
            attributes: {
                ...data?.visit?.attributes,
                examLevel: data?.visit?.attributes?.examLevel
                    ? {
                        id: data?.visit?.attributes?.examLevel,
                        name: data?.visit?.attributes?.examLevelName,
                        code: data?.visit?.attributes?.examLevelCode,
                    }
                    : null,
            },
        },
        orders: data?.orders?.filter((order: any) => !order?.isClinical),
        insurance: {
            ...data.insurance,
            ...getInitialDateValue(data?.insurance, 'insFrom'),
            ...getInitialDateValue(data?.insurance, 'insTo'),
            ...getInitialDateValue(data?.insurance, 'insNgaydu5nam'),
            ...getInitialDateValue(data?.insurance, 'insNgaymienchitra'),
            ...splitInsuranceCode(data?.insurance?.insCode),
        },
        initialDetailValues: data,
    };
};

export const convertPatientDataFromIDQR = (value: any, patientValues: any = {}) => {
  return {
    ...patientValues,
    person: {
      ...patientValues?.person,
      fullName: value.hoTen?.toUpperCase(),
      dobDay: value.ngaySinh,
      dobMonth: value.thangSinh,
      dobYear: value.namSinh,
      idNumber: value.soCccd,
      gender: value.genderOption,
    },
    province: value?.provinceOption,
    commune: value?.wardOption,
    address: value?.address || value?.town,
    ethnicity: value?.ethnicity || patientValues?.ethnicity,
    administrativeUnit: value?.wardOption?.shortName || value?.administrativeUnit,
  }
}

export const checkInsuranceInfoChange = (initialValue: any, currentValue: any) => {
    if (!initialValue || !currentValue) {
        return false;
    }

    const FIELD_CHECK = [
        'insCodeDoiTuong',
        'insCodeMucHuong',
        'insCodeNoiPhatHanh',
        'insCodeMaBhxh',
        'insFromYear',
        'insFromMonth',
        'insFromDay',
        'insToYear',
        'insToMonth',
        'insToDay',
    ];

    return FIELD_CHECK.some((field: string) => initialValue[field] !== currentValue[field]);
};

export const splitInsuranceCode = (code: string) => {
	if (!code) return {};

	if (code.length === 10) {
		return {
			insCodeMaBhxh: code,
		};
	}

	return {
		insCodeDoiTuong: code.slice(0, 2),
		insCodeMucHuong: code.slice(2, 3),
		insCodeNoiPhatHanh: code.slice(3, 5),
		insCodeMaBhxh: code.slice(5),
	};
};

export const convertInsData = (data: any) => {
  const insKcbbdCode = data?.maDKBDMoi || data.maDKBD || data?.maNoiKCB?.replace(/[-\s]/g, '') || "";
  const insKcbbdName = data.tenDKBD || "";
  const insFrom = convertNgay(data?.gtTheTuMoi || data?.gtTheTu);
  const insTo = convertNgay(data?.gtTheDenMoi || data?.gtTheDen);
  const insNgaydu5nam = convertNgay(data.ngayDu5Nam || data.thoiDiem5NamLienTuc);
  const maSoBHYT = splitInsuranceCode(data.maThe || data.maSoBHYT);
  const effectiveFrom = convertNgay(data?.gtTheTuMoi || data?.gtTheTu || data?.giaTriSuDungTuNgay);
  const effectiveTo = convertNgay(data?.gtTheDenMoi || data?.gtTheDen || data?.giaTriSuDungDenNgay);
  const insAddress = data.diaChi || data?.insAddress; // diaChi: lookup, insAddress: qr scan

  return {
    ...splitInsuranceCode(data.maThe || data.maSoBHYT),
    insCodeDoiTuong: maSoBHYT.insCodeDoiTuong || data?.maDoiTuong,
    insCodeMucHuong: maSoBHYT.insCodeMucHuong || data?.maMucHuong,
    insCodeNoiPhatHanh: maSoBHYT.insCodeNoiPhatHanh,
    insCodeMaBhxh: maSoBHYT.insCodeMaBhxh,
    insKcbbdCode,
    insKcbbdName,
    insFromDay: insFrom.ngay,
    insFromMonth: insFrom.thang,
    insFromYear: insFrom.nam,
    insToDay: insTo.ngay,
    insToMonth: insTo.thang,
    insToYear: insTo.nam,
    effectiveFromDay: effectiveFrom.ngay,
    effectiveFromMonth: effectiveFrom.thang,
    effectiveFromYear: effectiveFrom.nam,
    effectiveToDay: effectiveTo.ngay,
    effectiveToMonth: effectiveTo.thang,
    effectiveToYear: effectiveTo.nam,
    insNgaydu5namDay: insNgaydu5nam.ngay,
    insNgaydu5namMonth: insNgaydu5nam.thang,
    insNgaydu5namYear: insNgaydu5nam.nam,
    insAddress,
  }
}

export const convertNgay = (value: string = '') => {
  if (value.includes('/')) {
    const [ngay, thang, nam] = value.split('/');
    return {ngay, thang, nam,};
  }

  let ngay = null,
    thang = null,
    nam = null;

  if (value.length === 8) {   // case: DD(?)MM(?)YYYY  |  (?): separator (/,-,...)
    ngay = value.slice(0, 2);
    thang = value.slice(2, 4);
    nam = value.slice(4);
  }

  if (value.length === 6) {   // case: MM/YYYY
    thang = value.slice(0, 2);
    nam = value.slice(2);
  }

  if (value.length === 4) {   // case: YYYY
    nam = value;
  }

  return {ngay, thang, nam,};
};

export const getSubDistrictByShortName = (shortName: string, listSubDistrict: any[]) => {
  return listSubDistrict.find(item => item.shortName === shortName.toUpperCase()) || null;
}

export const getProvinceById = (provinceId: string, listProvinces: any[]) => {
  return listProvinces.find((item: any) => item?.id === provinceId) || null;
}

export const getDepartmentOpt = (value: any, listDepartment: any[]) => {
  return listDepartment.find(
    (item: any) => item?.code === value?.attributes?.deptClinicCode
      || item?.code === value?.attributes?.deptLaboratoryCode
  )
}

export const getSubDistrictByProvinceId = (provinceId: string, listSubDistrict: any[]) => {
  if (!provinceId || !listSubDistrict.length) return [];
  return listSubDistrict.filter((item: any) => item?.provinceId === provinceId) || [];
}

export const getOptionByCode = (code: string, listOptions: any[]) => {
  return listOptions.find((item: any) => item?.code === code) || null;
}

export const isPatientChange = (oldPatient: any, newPatient: any): boolean => {
  const hasOldHoTen = Boolean(oldPatient?.hoTen);
  const hasOldFullName = Boolean(oldPatient?.person?.fullName);
  const hasNewHoTen = Boolean(newPatient?.hoTen);
  const normOldHoTen = oldPatient?.hoTen?.toLowerCase();
  const normNewHoTen = newPatient?.hoTen?.toLowerCase();
  const normOldFullName = oldPatient?.person?.fullName?.toLowerCase();

  return (normOldHoTen !== normNewHoTen && hasOldHoTen && hasNewHoTen)
    || (normOldFullName !== normNewHoTen && hasOldFullName && hasNewHoTen)
    || (!hasOldHoTen && !hasOldFullName && hasNewHoTen);
}

const isSubDistrict = (text: string): boolean => {
  return ADDRESS_PREFIX.TRIMMED_WARD_PREFIX.some(d => text.trim().includes(d))
}

const isProvince = (text: string): boolean => {
  return ADDRESS_PREFIX.TRIMMED_PROVINCE_PREFIX.some(d => text.trim().includes(d))
}

const isDistrict = (text: string): boolean => {
  return ADDRESS_PREFIX.TRIMMED_DISTRICT_PREFIX.some(d => text.trim().includes(d))
}

const replaceAdressPrefix = (address: string, prefix?: string | string[], alterString?: string) => {
  if (!address) return '';

  if (Array.isArray(prefix)) {
    return prefix.reduce((acc, cur) => {
      return acc.replaceAll(cur || "", alterString || "");
    }, address);
  }

  return address.replaceAll(prefix || "", alterString || "");
}

export const checkAddress = (address: string, isLookup?: boolean): string => {
  const diaChi = address?.includes("-") ? address?.replaceAll("-", ",") : address;
  const diaChiSplitted = diaChi?.split(",") || [];
  const {PROVINCE_PREFIX, DISTRICT_PREFIX,WARD_PREFIX} = ADDRESS_PREFIX;

  switch (diaChiSplitted.length) {
    case 2: {
      // case: Xã/Phường, Tỉnh/TP.
      const [address1, address2] = diaChiSplitted;

      return ["", address1, address2].join(',');
    }
    case 3: {
      const [address1, address2, address3] = diaChiSplitted;

      if (isLookup) { // thông tin trả về từ cổng bhyt
        //case: thôn/phố, phường/xã, tỉnh/tp (địa chỉ mới)
        if (isSubDistrict(address2) && isProvince(address3)) {
          return diaChi.replaceAll(" ,", ",");
        }

        // case: xã/phường, huỵện/quận, tỉnh/tp (địa chỉ cũ)
        return ("," + diaChi).replaceAll(" ,", ",");
      }

      return replaceAdressPrefix(diaChi, [...PROVINCE_PREFIX, ...DISTRICT_PREFIX, ...WARD_PREFIX,], "");
    }
    case 4: {
      const [address1, address2, address3, address4] = diaChiSplitted;

      if (isLookup) {
        if (isProvince(address4) && isSubDistrict(address3)) {
          const town = [address1, address2].join('.');
          return [town, address3.trim, address4].join(',').replaceAll(", ", ",");
        } else if (isSubDistrict(address2) && isDistrict(address3) && isProvince(address4)) {
          return replaceAdressPrefix(diaChi, [...PROVINCE_PREFIX, ...DISTRICT_PREFIX, ...WARD_PREFIX,], "");
        }
      }

      return diaChi;
    }
    case 5: {
      const [address1, address2, ...rest] = diaChiSplitted;

      if (isDistrict(address2)) {
        //case: phường/xã, quận/huyện, tỉnh, phường/xã, tỉnh
        return "," + diaChiSplitted.slice(0, 3).join(',');
      }

      // case: số nhà 1, số nhà 2, phường/xã, huỵện/quận, tỉnh
      // return `${address1}. ${address2}, ${rest.join(',')}`;
      return [`${address1}.${address2}`, ...rest].join(',').replaceAll(", ", ",")
    }
    case 7: // Case: 2 địa chỉ nối nhau
      const newAddress = diaChiSplitted.slice(0, 4).map(item => item.trim());
      return newAddress.join(',');
    default:
      return address;
  }
}
